module.exports = __webpack_public_path__ + "store/img/collar-placeholder.6237a539.svg";